export interface ColorInput {
  nombre: string;
  codigoColor: string | null;
}

export const LOOKUP: Record<string, string> = {
  'negro':               '#000000',
  'blanco':              '#FFFFFF',
  'rojo':                '#E53935',
  'azul':                '#1E88E5',
  'verde':               '#43A047',
  'amarillo':            '#FDD835',
  'naranja':             '#FB8C00',
  'morado':              '#8E24AA',
  'violeta':             '#8E24AA',
  'lila':                '#CE93D8',
  'rosa':                '#E91E63',
  'fucsia':              '#F50057',
  'gris':                '#757575',
  'gris oscuro':         '#424242',
  'gris claro':          '#BDBDBD',
  'cafe':                '#795548',
  'café':                '#795548',
  'marron':              '#795548',
  'marrón':              '#795548',
  'castaño':             '#795548',
  'beige':               '#F5F5DC',
  'crema':               '#FFFDD0',
  'dorado':              '#FFD700',
  'oro':                 '#FFD700',
  'plateado':            '#C0C0C0',
  'plata':               '#C0C0C0',
  'turquesa':            '#00BCD4',
  'celeste':             '#29B6F6',
  'coral':               '#FF7043',
  'salmón':              '#FA8072',
  'salmon':              '#FA8072',
  'lima':                '#C6EF3F',
  'terracota':           '#BF5A1F',
  'vino':                '#880E4F',
  'burdeos':             '#880E4F',
  'navy':                '#1A237E',
  'azul marino':         '#1A237E',
  'azul royal':          '#4169E1',
  'azul rey':            '#4169E1',
  'azul cielo':          '#87CEEB',
  'verde militar':       '#4B5320',
  'verde olivo':         '#808000',
  'verde agua':          '#00BFA5',
  'verde menta':         '#98FF98',
  'verde limon':         '#C6EF3F',
  'naranja quemado':     '#CC5500',
  'rojo vino':           '#722F37',
  'rojo oscuro':         '#B71C1C',
  'azul oscuro':         '#0D47A1',
  'verde oscuro':        '#1B5E20',
  'amarillo ocre':       '#CC7722',
  'negro mate':          '#1C1C1C',
  'blanco hueso':        '#FAF9F6',
  'transparente':        '#E0E0E0',
};

export function normalizeColorName(name: string): string {
  return name.normalize('NFD').replace(/\p{Mn}/gu, '').trim().toLowerCase();
}

function hashColor(name: string): string {
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
    hash |= 0;
  }
  const hue = ((hash % 360) + 360) % 360;
  return `hsl(${hue}, 55%, 45%)`;
}

export function resolveColor(colorVariante: ColorInput): string {
  if (colorVariante.codigoColor) return colorVariante.codigoColor;
  const key = normalizeColorName(colorVariante.nombre);
  return LOOKUP[key] ?? hashColor(key);
}
